import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-desktop.tsx
/**
* icon.24.desktop
*
* Keywords: monitor, display, screen, computer, television
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNiAxNVY4aDEydjd6TTUgNy41YS41LjUgMCAwIDEgLjUtLjVoMTNhLjUuNSAwIDAgMSAuNS41djhhLjUuNSAwIDAgMS0uNS41SDE0djFoLjVhLjUuNSAwIDAgMSAwIDFoLTVhLjUuNSAwIDAgMSAwLTFoLjV2LTFINS41YS41LjUgMCAwIDEtLjUtLjV6bTYgOC41djFoMnYtMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-8603
*/
const Icon24Desktop = memo(function Icon24Desktop(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6 15V8h12v7zM5 7.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H14v1h.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h.5v-1H5.5a.5.5 0 0 1-.5-.5zm6 8.5v1h2v-1z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Desktop };

//# sourceMappingURL=icon-24-desktop.js.map